import React, { useState, useEffect } from "react";
import CircularChart from "./CircularChart";

const initialChartData = [
  { label: "Dialled Calls", value: 0, color: "#4CAF50" },
  { label: "Connected Calls", value: 0, color: "#2196F3" },
  { label: "Followups Created", value: 0, color: "#FFC107" },
  { label: "Demo Booked", value: 0, color: "#9C27B0" },
  { label: "Callbacks Requested", value: 0, color: "#FF5722" },
  { label: "Demo Successful", value: 0, color: "#00BCD4" },
  { label: "Conversions", value: 0, color: "#795548" },
];

const ChartWithIndicators = ({ data }) => {
  const [chartData, setChartData] = useState(initialChartData);
  const [totalLeads, setTotalLeads] = useState(0);

  useEffect(() => {
    if (!Array.isArray(data) || data.length === 0 || !Array.isArray(data[0])) return;
  
    const [generalStats, followupStats] = data[0];
  
    if (!generalStats || !followupStats) return;
  
    const updatedData = initialChartData.map((item) => {
      switch (item.label) {
        case "Followups Created":
          return { ...item, value: followupStats["Follow Up"] || 0 };
        case "Demo Booked":
          return { ...item, value: followupStats["Demo Booked"] || 0 };
        case "Callbacks Requested":
          return { ...item, value: followupStats["Call Back"] || 0 };
        case "Dialled Calls":
          return { ...item, value: generalStats["dialled_calls"] || 0};
        default:
          return item;
      }
    });

    setChartData(updatedData);
    setTotalLeads(generalStats["unique_leads_touched"] || 0);
  }, [data]);   
  
  const half = Math.ceil(chartData.length / 2);
  const leftIndicators = chartData.slice(0, half);
  const rightIndicators = chartData.slice(half);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "40vh",
        gap: "40px", // spacing between columns
      }}
    >
      {/* Left Indicators */}
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {leftIndicators.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "14px",
            }}
          >
            <div
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: item.color,
                borderRadius: "2px",
              }}
            />
            <span>{item.label}: {item.value}</span>
          </div>
        ))}
      </div>

      {/* Center Chart */}
      <CircularChart data={chartData} size={200} strokeWidth={20} totalLeads={totalLeads} />

      {/* Right Indicators */}
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {rightIndicators.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "14px",
            }}
          >
            <div
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: item.color,
                borderRadius: "2px",
              }}
            />
            <span>{item.label}: {item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChartWithIndicators;
